export default __webpack_public_path__ + "static/media/water-1.c7dc9a22.png";